import React, { useState } from 'react'
import { Button } from 'semantic-ui-react'
import { useEvent } from '@hooks/useEvent'
import { useDispatch, useSelector } from 'react-redux'
import { updateShipmentFieldValue } from "../../reducer/headerSlice";
// import { itemActions } from '../../reducer/ItemSlice'
import { HttpClient } from '../../../../commonApis/httpClient'
import { SetSaveEvent } from '../../../../commonApis/formEvents'
import { useCurrentShipmentType } from '@hooks/useCurrentShipmentType'
import ReturnToEditButton from '../../../../header/ButtonMapper/returnToEditButton';
import { updateWorkFlow } from '../../../../commonApis';
import { ModalLoader } from '@commonComponents/ModalLoader';


const FileEmergencyProcedure = ({ translate, ...props }) => {
    const [isLoading, setLoader] = useState(false)
    const { saveForm } = useEvent()
    const dispatch = useDispatch()
    const { isImportShipment } = useCurrentShipmentType()
    const merchandiseMap = useSelector((state) => state.invoiceReducer.invoice.merchandiseMap)
    // const { addMerchanidseDocById } = itemActions
    const params = !isImportShipment ? {
        pdfType: "CLIENT_PDF_DMS_EXPORT",
        countryCode: "nl-dms-export",
        isEmergency: true,
        addDocumentNew: 'TRUE'
    } : {}
    const eventName = isImportShipment ? "GENERATE_EMERGENCY_PROCEDURE_DOCUMENT_DMS" : "GENERATE_PDF"


    const fileEmergencyProcedureDocument = async () => {
        setLoader(true)
        const data = SetSaveEvent(eventName, { "shipmentId": props?.shipId, ...params })
        const response = await HttpClient.custom({ data })
        setLoader(false)
        const url = response?.data?.eventMessage?.url
        if (url) {
            const pdfWindow = window.open()
            pdfWindow.location.href = url
            const wfState = props?.customState?.includes('SENT') ? "NOOD_FILED_DECL_SENT" : "NOOD_FILED_DECL_NOT_SENT"
            const res = await saveForm({
                upperHeader: { 
                    mrn: "EMERGENCY_PROCEDURE",
                    emergencyProcedure: true 
                } 
            })
            if (res?.upperHeader) {
                dispatch(updateShipmentFieldValue({ emergencyProcedure: true }))
                // const { id: merchandiseId, invoiceId } = Object.values(merchandiseMap)?.reduce((min, current) => {
                //     return (Number(current?.ordinalNumber) < Number(min?.ordinalNumber) ? current : min)
                // });
                
                await updateWorkFlow(props?.shipId, wfState, props?.currentJobData?.brokerGuid)
                await HttpClient.custom({
                    data: {
                        eventId: "",
                        eventTime:Date.now(),
                        eventMessage: {selectedShipments:[{shipmentId:props?.shipId}]},
                        eventType: {
                            NOOD_FILED_DECL_SENT:'FILE_DECL_SENT',
                            NOOD_FILED_DECL_NOT_SENT:'FILE_DECL_NOT_SENT'
                        }[wfState]
                    }
                })
                // const params = {
                //     type: 'NP500',
                //     description: 'INF',
                //     identification: 'NOODPROCEDURE DMS'
                // }
                // const _emergencyProcedureDocument = !merchandiseMap[merchandiseId]['additionalDocumentsList']?.some((item) => (item.type == 'NP500' && item.identification == 'NOODPROCEDURE DMS'))
                // if (_emergencyProcedureDocument) {
                //     const response = await saveForm({
                //         invoiceTab: {
                //             merchandiseMap: {
                //                 [`${merchandiseId}`]: {
                //                     invoiceId, additionalDocumentsList: [{ id: '', merchandiseId, invoiceId, ...params }]
                //                 }
                //             }
                //         }
                //     }, true)
                //     if (response) {
                //         const data = response.invoiceTab.merchandiseMap[merchandiseId]['additionalDocumentsList'][0]
                //         dispatch(addMerchanidseDocById({
                //             data: { ...data, invoiceId, merchandiseId, ...params },
                //             meta: { tableName: 'additionalDocumentsList' },
                //         }))
                //     }
                // }
            }
            document.getElementById(`card-${props?.shipId}`).click();
        }
    }

    return (
        <Button.Group>
            <ReturnToEditButton translate={translate} {...props} />
            {isLoading && (
                <ModalLoader loading={isLoading} message='Loading...' />
            )}
            <Button
                size="mini"
                key="EMERGENCY_PROCEDURE"
                className="sv todo-button secondaryBtn"
                onClick={(e) => {
                    e.stopPropagation();
                    fileEmergencyProcedureDocument();
                }}
            >
                {translate(`EMERGENCY_PROCEDURE`).toUpperCase()}
            </Button>
        </Button.Group>
    );
}

export default FileEmergencyProcedure